document.addEventListener(
  'DOMContentLoaded',
  function () {
    const paragraphs = document.querySelectorAll(
      '.wysiwyg p, .callout__text p'
    );

    if (paragraphs.length !== 0) {
      const regex = /g?(\d{1})\/(\d{1})/g; // integer, slash, integer, space (e.g '1/2 ', '8/7 ')
      const regex_multiple_digits_top = /g?(\d{2,})\/(\d{1})/g; // integer, slash, integer, space (e.g '12/2 ', '16/7 ')
      const formatFraction = (element) => {
        let formattedElement = element.innerHTML.replace(regex, '&frac$1$2;');
        element.innerHTML = formattedElement;
      };

      paragraphs.forEach((value) => {
        const paragraphFractionTest = regex.test(value.innerHTML);
        const multiple_integer_numerator = regex_multiple_digits_top.test(
          value.innerHTML
        );

        if (
          paragraphFractionTest === true &&
          multiple_integer_numerator === false
        ) {
          let paragraphContainsFraction = value;
          formatFraction(paragraphContainsFraction);
        }
      });
    }
  },
  false
);
